import { Controller } from "stimulus";

export default class NavbarController extends Controller {

    connect() {
    }

    campaignRename() {
        let name = document.getElementById('modal_campaign_name').value.trim();
        if (!name) return;

        document.querySelector('#campaign-name .underline').textContent = name;
        let campaignName = document.getElementById('campaign_name');
        if (campaignName) campaignName.value = name;
        $('#campaign-rename-modal').modal('hide');
        toastr.success('Campaign has been renamed.');
    }
}
